// Styled Components
import styled from "styled-components";

// Material UI
// import Button from "@mui/material/Button";
import { Button } from "@material-ui/core";

// Components
import GenerateItemsItem from "./GenerateItemsItem/GenerateItemsItem";

const GenerateItems = () => {
  return (
    <Wrapper>
      <div className="group-1">
        <GenerateItemsItem />
        <GenerateItemsItem />
      </div>

      <div className="group-2">
        <GenerateItemsItem />
        <GenerateItemsItem />
      </div>

      <p className="equal">=</p>

      <div className="final">
        <div className="box"></div>
        <Button variant="contained" className="button">
          MINT
        </Button>
        <p className="name">NFT NAME</p>
      </div>
    </Wrapper>
  );
};

export default GenerateItems;

const Wrapper = styled.div`
  width: 100%;
  padding-top: 50px;

  z-index: 101;

  //
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  @media only screen and (max-width: 1275px) {
    flex-direction: column;
  }
  //

  .group {
    &-1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      gap: 20px;

      @media only screen and (max-width: 1275px) {
        justify-content: center;
        gap: 20px;
      }
    }

    &-2 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      gap: 20px;

      @media only screen and (max-width: 1275px) {
        justify-content: center;
        gap: 20px;
      }
    }
  }

  .equal {
    font-size: 5rem;

    @media only screen and (max-width: 1275px) {
      display: none;
    }
  }

  .final {
    .box {
      width: 300px;
      height: 316px;
      background-color: #000;

      border: 2px solid #fff;
    }

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 25px;

    .button {
      width: 250px;
      color: #fff;
      background-color: #000;
      font-family: interstate, sans-serif;
      font-size: 1rem;
      border-radius: 0px;
      font-weight: 900;

      border: 2px solid #fff;

      &:hover {
        background-color: #000;
      }
    }

    .name {
      font-size: 1.25rem;

      opacity: 0;
    }
  }
`;
